import { ArrowRight, Check } from 'lucide-react';
import { useNavigate, useOutletContext } from 'react-router-dom';
import { PROFILE_STEPS, getStepIndex, getPrevStep, stepRoute } from 'pages/Profile/helper';

const StepFooter = ({ stepId, isSubmitting = false, editMode = false, onCancel = null }) => {
  const { embedded = false }: any = useOutletContext() || {};
  const navigate = useNavigate();
  const index = getStepIndex(stepId);
  // Embedded (/portal/forms, mobile WebView) shows a single form: no step counter, no Back, submit reads "Finish".
  const isLast = embedded || index === PROFILE_STEPS.length - 1;
  const prev = !embedded && getPrevStep(stepId);

  const primary = 'inline-flex items-center gap-2 whitespace-nowrap rounded-[10px] px-4 py-2.5 text-[13px] font-semibold text-white transition-colors disabled:opacity-60 sm:px-5 sm:py-[11px] sm:text-sm';
  const secondary = 'inline-flex items-center whitespace-nowrap rounded-[10px] border-[1.5px] border-secondary-200 bg-white px-4 py-2.5 text-[13px] font-semibold text-secondary-600 transition-colors hover:border-secondary-300 hover:bg-secondary-50 disabled:opacity-60 sm:px-5 sm:py-[11px] sm:text-sm';

  return (
    <div className={`flex flex-shrink-0 items-center justify-end gap-3 border-t border-gray-100 bg-white px-4 py-3 sm:px-5 sm:py-3.5 lg:px-10 ${embedded ? '' : 'sm:justify-between'}`}>
      {!embedded && (
        <span className="hidden text-[12.5px] font-medium text-secondary-400 sm:block">
          {editMode ? 'Editing — nothing changes until you save' : `Step ${index + 1} of ${PROFILE_STEPS.length}`}
        </span>
      )}

      <div className="flex items-center gap-2.5">
        {editMode ? (
          <button type="button" onClick={onCancel} disabled={isSubmitting} className={secondary}>
            Cancel
          </button>
        ) : prev && (
          <button
            type="button"
            onClick={() => navigate(stepRoute(prev))}
            disabled={isSubmitting}
            className={secondary}
          >
            Back
          </button>
        )}

        {editMode ? (
          <button type="submit" disabled={isSubmitting} className={`${primary} bg-secondary-900 hover:bg-black`}>
            {isSubmitting ? <span className="loading loading-spinner loading-sm" /> : <><Check size={15} strokeWidth={2.8} /> Save changes</>}
          </button>
        ) : isLast ? (
          <button type="submit" disabled={isSubmitting} className={`${primary} bg-success-500 hover:bg-success-600`}>
            {isSubmitting ? <span className="loading loading-spinner loading-sm" /> : <><Check size={15} strokeWidth={2.8} /> Finish</>}
          </button>
        ) : (
          <button type="submit" disabled={isSubmitting} className={`${primary} bg-secondary-900 hover:bg-black`}>
            {isSubmitting ? <span className="loading loading-spinner loading-sm" /> : <>Save &amp; continue <ArrowRight size={15} strokeWidth={2.5} /></>}
          </button>
        )}
      </div>
    </div>
  );
};

export default StepFooter;
